import React from "react";
import ReusableForm from "../../../../../components/reusable/ReusableForm";

const DepartmentForm = ({
    isOpen,
    onClose,
    onSubmit,
    offices = [],
    initialValues = {},
    submitLabel = "Create Department",
}) => {
    const officeOptions = offices.map((office) => ({
        value: office.id,
        label: office.name,
    }));

    const fields = [
        {
            name: "name",
            label: "Department Name",
            type: "text",
            required: true,
            placeholder: "Enter department name",
        },
        {
            name: "code",
            label: "Department Code",
            type: "text",
            required: true,
            placeholder: "Enter department code",
        },
        {
            name: "office",
            label: "Office",
            type: "select",
            required: false,
            placeholder: "Select office",
            options: officeOptions,
        },
        {
            name: "description",
            label: "Description",
            type: "textarea",
            required: false,
            placeholder: "Enter department description",
        },
    ];

    return (
        <ReusableForm
            isOpen={isOpen}
            onClose={onClose}
            title={
                initialValues?.id
                    ? "Edit Department"
                    : "Create Department"
            }
            fields={fields}
            initialValues={initialValues}
            onSubmit={onSubmit}
            submitLabel={submitLabel}
        />
    );
};

export default DepartmentForm;
